<template>
  <div class="d-flex flex-wrap gap align-start">
    <BaseCard width="400">
      <BaseInput
        type="switch"
        :label="t['setting-setting_company'].all['several_times_a_day']"
        v-model="data['several-times']"
        :view-value="m[data['several-times'] ? 'yes' : 'no']"
        :view="!edit"
      />
    </BaseCard>
    <BaseCard
      width="600"
      max-width="100%"
      :title="t['setting-setting_company'].all['automatic_stop_function']"
    >
      <div class="d-flex flex-wrap gap">
        <div v-if="edit || (!edit && data['default_end_type'] === 0)">
          <v-btn
            v-if="edit"
            text
            @click="data['default_end_type'] = 0"
            color="primary"
            class="text-none"
          >
            <v-icon left v-if="data['default_end_type'] === 0">mdi-radiobox-marked</v-icon>
            <v-icon left v-else>mdi-radiobox-blank</v-icon>
            <span>{{ t['setting-setting_company'].all['time_of_day'] }}</span>
          </v-btn>
          <v-sheet width="150">
            <BaseInput
              :label="edit ? null : t['setting-setting_company'].all['time_of_day']"
              v-model="data.default_end_time"
              input-type="time"
              :view="!edit"
            />
          </v-sheet>
        </div>
        <div v-if="edit || (!edit && data['default_end_type'] === 1)">
          <v-btn
            v-if="edit"
            text
            @click="data['default_end_type'] = 1"
            color="primary"
            class="text-none"
          >
            <v-icon left v-if="data['default_end_type'] === 1">mdi-radiobox-marked</v-icon>
            <v-icon left v-else>mdi-radiobox-blank</v-icon>
            <span>{{ t['setting-setting_company'].all['diapason'] }}</span>
          </v-btn>
          <v-sheet width="150">
            <div class="d-flex align-center">
              <BaseInput
                :label="edit ? null : t['setting-setting_company'].all['diapason']"
                v-model="data.default_end_work_period"
                type="select"
                :items="range_time"
                :view-value="data.default_end_work_period + ' ' + t.common.measure['hours_min']"
                :view="!edit"
              />
              <div v-if="edit" class="ml-1 f14">
                {{ t.common.measure['hours_min'] }}
              </div>
            </div>
          </v-sheet>
        </div>
      </div>
    </BaseCard>
    <div class="fixedBtn">
      <BaseTooltip v-if="edit" :tooltip="t.common['buttons']['sohranit']">
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="onSave"
          round
          icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip v-else :tooltip="t.common['buttons']['redaktirovat']">
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit" />
      </BaseTooltip>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'settingCompanyStartStop',
  data: () => ({
    data: {
      'several-times': false,
      manually: false,
      default_end_type: 0,
      default_end_work_period: -1,
      default_end_time: '',
    },
    range_time: [1, 2, 3, 4, 6, 8, 12],
    key: 0,
    temp: null,
  }),
  computed: {
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    t() {
      return this.localStorage.translations.pages
    },
    n() {
      return this.t.common.notifications
    },
    m() {
      return this.localStorage.mobile.pages['mob_modal'].common
    },
    edit() {
      return this.$route.name === 'SettingCompanyStartStopEdit'
    },
  },
  watch: {
    data: {
      handler() {
        if (this.edit) this.onCheckChange({ overwrite: false })
      },
      deep: true,
    },
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    temp() {
      this.formatData(this.temp)
    },
  },
  created() {
    this.onLoadData()
  },
  methods: {
    ...mapActions('commonConfig', ['onCommonConfigSettings', 'onCommonConfigSettingsUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { companyStartStop: this.data },
        overwrite,
      })
    },
    async onLoadData() {
      await this.onCommonConfigSettings({ name: 'report' })
        .then((res) => {
          this.formatData(res.data)
          //this.key++
          //if (this.edit) this.onCheckChange({ overwrite: true })
        })
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            { message: this.n['oshibka'], IsError: false },
            { root: true },
          )
        })
    },

    formatData(data) {
      console.log('data', data)
      console.log('default_end_type', data['default_end_type'])
      this.data['several-times'] = data['only_once_a_day'] == 0
      this.data['manually'] = data['manually'] == 1
      this.data['default_end_type'] = data['default_end_type'] === 'day' ? 0 : 1
      this.data['default_end_work_period'] = data['default_end_work_period']
        ? Number(data['default_end_work_period'].split(':')[0])
        : 8
      this.data['default_end_time'] = data['default_end_time']
        ? data['default_end_time'].slice(0, -3)
        : '00:00'
    },

    onEdit() {
      this.$router.push({
        name: this.edit ? 'SettingCompanyStartStop' : 'SettingCompanyStartStopEdit',
      })
    },
    async onSave() {
      let temp = {
        only_once_a_day: this.data['several-times'] ? 0 : 1,
        manually: this.data['manually'] ? 1 : 0,
        default_end_type: this.data['default_end_type'] == 0 ? 'day' : 'time',
        default_end_work_period:
          String(this.data['default_end_work_period']).padStart(2, '0') + ':00:00',
        default_end_time: this.data['default_end_time'] + ':00',
      }
      await this.onCommonConfigSettingsUpdate({
        name: 'report',
        data: temp,
        notCommitToMain: true,
      })
        .then((res) => {
          console.log('res', res.data)
          this.formatData(res.data)
          this.onCheckChange({ overwrite: true })
          this.$store.dispatch(
            'popup/onMessage',
            { message: this.n['izmeneniya-uspeshno-sohraneny'], IsError: false },
            { root: true },
          )
          setTimeout(() => {
            this.onEdit()
          }, 300)
        })
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            { message: this.n['oshibka'], IsError: false },
            { root: true },
          )
        })
    },
  },
}
</script>

<style scoped lang="scss">
.gap {
  gap: 20px;
}

:deep() .v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
}
</style>